<template>
  <div  :class="['main-content','sn-content']">
    <el-card v-if="user.status == '2'" class="box-card">
      <div>
        <div class="vertical">
          <i  class="el-icon-warning-outline" style="color: orange"></i>
          <router-link  :to="{path:'/uac/authc'}"  style="color: orange">去认证</router-link>
        </div>
        <p class="tag" style="">企业用户请先进行账号认证，认证通过后，才可以申请代理转发服务</p>
      </div>
    </el-card>

    <div v-else class="box-card is-always-shadow">
      <el-form ref="form" :model="form" :rules="rules" label-position="top">
          <el-form-item label="" prop="name">
            <div class="pxy-tag-label">
              <span style="width: 200px">名称</span>
            </div>
            <el-input placeholder="30个字符以内，例如项目名" v-model="form.name" style="width:500px"></el-input>
          </el-form-item>
      </el-form>
        <div  class="item pxy-form-item pxy-form-item-line" style="text-align: right">
          <el-button type="primary" class="pxy-primary" plain @click="updateAgentInfo()">确认</el-button>
        </div>
      </div>
  </div>

</template>

<script>
  import {Message} from "element-ui";

  export default {
    components: {},
    data() {
      return {
        loading: false,
        form: {
          clientId: this.$route.query.clientId,
          name: '',
        },
        rules: {
          name: [{max: 30, message: "长度在30个字符以内", trigger: 'blur'}],},
      }
    },
    created() {
    },
    methods: {
      updateAgentInfo: function () {
        var _this = this;
        var params = {};
        params.clientId = _this.form.clientId;
        params.name = _this.form.name;
        this.$refs["form"].validate((valid) => {
          if (valid) {
            this.loading = true;
            this.postRequestJson('/pocTurnKey/update', JSON.stringify(params)).then(resp => {
              _this.loading = false;
              if (resp && resp.status == 200) {
                var data = resp.data;
                if (data.code == 1000) {
                  Message.success(data.message);
                  this.$router.replace({path: '/agent/index'});

                } else {
                  Message.error(data.message);

                }
              }
            });
          }
        })
      },
      getAgentInfo: function () {
        this.getRequest('/pocTurnKey/getById', {clientId: this.form.clientId}).then(resp => {
          console.log(resp);
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.form = Object.assign(this.form,resp.data.result);
            }
          }
        })
      },
    }
    ,
    mounted: function () {
      this.getAgentInfo()
    }
    ,
    computed: {
      user() {
        return this.$store.state.user;
      },
    },
    beforeDestroy() {

    }
  }
</script>

<style scoped>
.sn-content .pxy-form-item .el-checkbox{
  float: none;
}
.box-card {
  text-align: left;
    border: 1px solid #EBEEF5;
    background-color: #FFF;
    color: #303133;
    border-radius: 4px;
    padding: 20px;

}
@media screen and (max-width: 768px) {
  /* 1px solid #EBEEF5 */
  .pxy-form-item .el-form-item__content .el-tag {
    height: auto!important;
    white-space: normal!important;
  }
  .pxy-form-item {
    margin-bottom: 10px!important;
    padding-bottom: 15px!important;
    box-sizing: border-box!important;
  }
  .pxy-form-item-line {
    border-bottom: 1px solid #EBEEF5!important;
  }
}

@media screen and (min-width: 769px) {
  .pxy-form-item .el-form-item__content {
    margin-left: 0!important;
  }
  .pxy-form-item .el-form-item__content .el-tag {
    margin-left: 10px!important;
  }
  .pxy-tag-label {
    display: inline-block;
  }
}
</style>
